<template>
  <gs-wizard-step>
    <p-row>
      <p-col xs12 md9 lg6 xl5>
        <h4 class="mb-4 mt-2">
          {{ $t('memberPortal.classifyHotel.label.classificationSuccessTitle') }}
        </h4>
        <p>{{ $t('memberPortal.classifyHotel.label.classificationSuccessText') }}</p>
      </p-col>
    </p-row>
  </gs-wizard-step>
</template>

<script lang="ts">
  import CreateHotelClassificationRequestViewModel from '../../../../../services/v1/viewModel/resource/CreateHotelClassificationRequestViewModel';
  import Vue from 'vue';

  export default Vue.extend({
    hasBackButton: true,
    auth: true,
    props: {
      value: { type: Object, default: undefined },
    },
    computed: {
      innerValue: {
        get(): CreateHotelClassificationRequestViewModel {
          return this.value ?? {};
        },
        set(value: CreateHotelClassificationRequestViewModel) {
          this.$emit('input', value);
        },
      },
    },
  });
</script>
